import * as env from '@/env'
import VConsole from 'vconsole';

let v: any = null
export default () => {
  if (v) return

  ;(window as any).d = {
    get r() {
      setTimeout(() => {
        location.reload()
      }, 1000)
      return 'reload in 1s'
    },

    get c() {
      setTimeout(() => {
        localStorage.clear()
        sessionStorage.clear()
        location.reload()
      }, 1000)
      return 'clear & reload in 1s'
    },

    get l() {
      log()
      return 'log'
    },

    get lh() {
      return location.href
    }
  }

  const log = () => {
    const version = (window as any)._v
    console.log('version', version)

    const envs = {
      mockEnv: env.params.get('mock'),
      mockApp: env.mockApp,
      isInPWA: env.isInPWA,
      isPwaInstalled: env.isPwaInstalled,
      isInApp: env.isInApp,
      isInIosApp: env.isInIosApp,
      isInAndroidApp: env.isInAndroidApp,
      isInIframe: env.isInIframe,
      hasJsBridge: env.hasJsBridge,
      hasOwnBridge: env.hasOwnBridge,
      isApl: env.isApl,
      isAp: env.isAp,
      isEbd: env.isEbd,
      isPlatform: env.isPlatform,
      isIOSSafari: env.isIOSSafari,
      isChrome: env.isChrome,
      isEdge: env.isEdge,
      isAndroid: env.isAndroid,
      isIOS: env.isIOS,
      isFromIOSScreen: env.isFromIOSScreen,
      isFacebookApp: env.isFacebookApp,
      isWebView: env.isWebView,
      sealing: env.sealing,
      isDesktop: env.isDesktop,
      isWindows: env.isWindows,
      isMacOS: env.isMacOS,
      isChromeOS: env.isChromeOS,
    }
    if (env.isDesktop) {
      console.log(
        '%c[******** ENV *** START *********]',
        'color: blue; font-size: 14px; font-weight: bold;',
      )
      console.table(envs)
    } else {
      console.log('[******** ENV *** START *********]')
      Object.keys(envs).forEach(key => {
        console.log(`${key}: ${envs[key]}`)
      })
    }
  }

  v = new VConsole();

  // 下次自动启动
  localStorage.setItem('_v', '1')

  setTimeout(() => {
    console.log(
      // @ts-ignore
      '%cver:' + window._v,
      'color: red; font-size: 16px; font-weight: bold;',
    )
  }, 1000)
}
